import { ForecastConfigInclude } from './ForecastConfig';
export var ForecastInclude = {
    forecastConfig: {
        include: ForecastConfigInclude,
    },
};
//# sourceMappingURL=Forecast.js.map